import React, { useContext } from 'react';
import { Col, Row } from 'antd';
import styles from '../../styles.module.pcss';
import classNames from 'classnames';
import { WidgetUI } from '@/types';
import { useNavigate } from 'react-router-dom';
import LayoutContext, { IFlexUserLayoutContext } from '@/context/FlexUserLayoutContext';

export const WidgetMaskItem: React.FC<{
  text: string;
  icon: React.ReactNode;
  disabled: boolean;
  name: WidgetUI;
  setActiveWidget: (name: WidgetUI) => void;
  currentActiveWidget?: WidgetUI;
  path?: string;
}> = ({ text, icon, name, setActiveWidget, disabled, currentActiveWidget, path }) => {
  const navigate = useNavigate();
  const layoutContext = useContext<IFlexUserLayoutContext>(LayoutContext);

  const onOpenWidgetPopup = () => {
    if (!disabled && !path) {
      setActiveWidget(name);
    }
    if (path) {
      layoutContext.toggleWidgetMask?.();
      layoutContext.setCurrentActiveWidget?.(name);
      navigate(path, { replace: true });
    }
  };

  return (
    <Row
      justify="center"
      align="middle"
      className={classNames(styles.menuItem, { [styles.menuItemActive]: name === currentActiveWidget })}
      onClick={(e) => {
        e.stopPropagation();
        onOpenWidgetPopup();
      }}
    >
      <Col
        span={16}
        className={classNames(styles.menuItemText, {
          [styles.menuItemTextActive]: name === currentActiveWidget,
        })}
      >
        {text}
      </Col>
      <Col span={4} offset={4}>
        {icon}
      </Col>
    </Row>
  );
};

export default WidgetMaskItem;
